import { render, staticRenderFns } from "./PpGoods.vue?vue&type=template&id=4a2e79b1&scoped=true&"
import script from "./PpGoods.vue?vue&type=script&lang=js&"
export * from "./PpGoods.vue?vue&type=script&lang=js&"
import style0 from "./PpGoods.vue?vue&type=style&index=0&id=4a2e79b1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2e79b1",
  null
  
)

export default component.exports